export default [
  {
    name: "balancaLista",
    path: "/balancas",
    redirect: { path: "/gerais", query: { aba: "balancas" } },
  },
];
